import { ReactComponent as SnapshotIcon } from 'src/assets/images/common/snapshot-white.svg';
import { ReactComponent as FlipkartIcon } from 'src/assets/images/common/flipkart-white.svg';
import { ReactComponent as AmazonIcon } from 'src/assets/images/common/amazon-white.svg';
import { ReactComponent as MasterOverviewIcon } from 'src/assets/images/common/master-overview.svg';
import { ReactComponent as MyntraIcon } from 'src/assets/images/myntra-white.svg';
import { ReactComponent as SettingsIcon } from 'src/assets/images/common/settings-white.svg';
import { ReactComponent as DaypartIconIcon } from 'src/assets/images/common/daypart.svg';
import { ReactComponent as UserActivityIcon } from 'src/assets/images/common/harvesting.svg';
import { ReactComponent as TimeSpendIcon } from 'src/assets/images/common/user-time-spend.svg';
import { ReactComponent as ClientListIcon } from 'src/assets/images/common/client-list.svg';
import { ReactComponent as UserAccountDetailsIcon } from 'src/assets/images/common/user-account.svg';
import { ReactComponent as CoupenIcons } from 'src/assets/images/common/coupen-dashboard.svg';
import { ReactComponent as CustomPaymentsIcon } from 'src/assets/images/common/seller-sales.svg';
import { ReactComponent as ClientAccessIcon } from 'src/assets/images/common/user-input-menu.svg';
import { ReactComponent as BlinkitIcon } from 'src/assets/images/common/blinkit-single.svg';
import { ReactComponent as DashboardIcon } from 'src/assets/images/common/ams-dash.svg';
import { ReactComponent as HectorGptIcon } from 'src/assets/images/common/chat.svg';
import { ReactComponent as InstamartIcon } from 'src/assets/images/common/instamart.svg';
import { ReactComponent as DspIcon } from 'src/assets/images/dsp/digital-transformation.svg';
import { ReactComponent as ZeptoIcon } from 'src/assets/images/zepto-white.svg';
import { ReactComponent as BigbasketIcon } from 'src/assets/images/bigbasket-white.svg';
import { ReactComponent as BillingPaymentsIcon } from 'src/assets/images/common/billing-payment.svg';
import { ReactComponent as BillingMenuIcon } from 'src/assets/images/common/billing-menu-icon.svg';
import HectorIcon from 'src/assets/icons/HectorIcon';
import BudgetRuleIcon from './assets/icons/BudgetRuleIcon';
import StatusRuleIcon from './assets/icons/StatusRuleIcon';
import PlacementRuleIcon from './assets/icons/PlacementRuleIcon';
import SearchTermRuleIcon from './assets/icons/SearchTermRuleIcon';
import SearchTermRuleNegationIcon from './assets/icons/SearchTermRuleNegationIcon';

export const isAllowedDomain = (email) => {
  if (!email) return false;
  
  const allowedDomains = ['@hectorai.live', '@neondigital.media'];
  return allowedDomains.some(domain => String(email).indexOf(domain) > -1);
};

const allowInternally = () => {
  const User = JSON.parse(localStorage.getItem('User')) || {};
  return User?.email ? isAllowedDomain(User.email) : false;
}

const flipkartProfileDetails = JSON.parse(sessionStorage.getItem('flipkartProfile'))

const isSuperMartAndMinuteProfile = flipkartProfileDetails && ['supermart', 'minutes'].includes(flipkartProfileDetails?.report_type)

const newMenuItems = [
  {
    title: 'Amazon',
    icon: <AmazonIcon />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/amazon/targeting'
      },
      // {
      //   label: 'Targeting 360',
      //   icon: <DashboardIcon />,
      //   path: '/amazon/marketing-stream'
      // },
      {
        label: 'Amazon CPC Jobs', 
        icon: <UserActivityIcon />,
        path: '/amazon/cpc-job-listing' 
      },
      {
        label: 'Snapshot',
        icon: <SnapshotIcon />,
        path: '/amazon-snapshot'
      },
      {
        label: 'Master Overview',
        icon: <MasterOverviewIcon />,
        path: '/amazon-master-overview'
      },
      {
        label: 'Dayparting',
        icon: <DaypartIconIcon />,
        path: '/amazon-dayparting-performance'
      },
      {
        label: 'DSP',
        icon: <DspIcon />,
        path: '/amazon-dsp/campaign'
      }
    ]
  },
  {
    title: 'Flipkart',
    icon: <FlipkartIcon />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/flipkart',
        isBeta: true,
      },
      ...(((flipkartProfileDetails?.V2 != true) || (flipkartProfileDetails?.V2 == true && flipkartProfileDetails?.sellerCPC == true)) ? [
      {
        label: 'Change History',
        icon: <UserActivityIcon />,
        path: '/flipkart/cpc-job-listing',
        isBeta: true,
      },
      ] : []),
      {
        label: 'Snapshot',
        icon: <SnapshotIcon />,
        path: '/flipkart-snapshot'
      },
      {
        label: 'Master Overview',
        icon: <MasterOverviewIcon />,
        path: '/flipkart-master-overview'
      },
      ...(((flipkartProfileDetails?.V2 != true) || (flipkartProfileDetails?.V2 == true && flipkartProfileDetails?.sellerCPC == true)) && !isSuperMartAndMinuteProfile ? [
      {
        title: 'Automation Rules',
        icon: <FlipkartIcon />, // Or Flipkart icon if you have one
        isBeta: true,
        items: [
          { label: 'Budget', icon: <BudgetRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/flipkart-automated-rules/budget' },
          { label: 'Status', icon: <StatusRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/flipkart-automated-rules/status' },
          { label: 'Placement', icon: <PlacementRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/flipkart-automated-rules/placement' },
          { label: 'ST Negation', icon: <SearchTermRuleNegationIcon fillColor='#fff' height="20px" width="20px" />, path: '/flipkart-automated-rules/searchterm-negation' },
          { label: 'ST Harvesting', icon: <SearchTermRuleIcon fillColor='#fff' height="20px" width="20px" />, path: '/flipkart-automated-rules/searchterm-harvesting' }
          ],
        }
      ] : [])
    ]
  },
  {
    title: 'Myntra',
    icon: <MyntraIcon />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/myntra',
        isBeta: true,
      }
      // {
      //   label: 'Snapshot',
      //   icon: <SnapshotIcon />,
      //   path: '/myntra-snapshot'
      // },
      // {
      //   label: 'Master Overview',
      //   icon: <MasterOverviewIcon />,
      //   path: '/myntra-master-overview'
      // }
    ]
  },
  {
    title: 'Blinkit',
    icon: <BlinkitIcon />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/blinkit'
      }
      // {
      //   label: 'Snapshot',
      //   icon: <SnapshotIcon />,
      //   path: '/myntra-snapshot'
      // },
      // {
      //   label: 'Master Overview',
      //   icon: <MasterOverviewIcon />,
      //   path: '/myntra-master-overview'
      // }
    ]
  },
  {
    title: 'Instamart',
    icon: <InstamartIcon />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/instamart'
      }
      // {
      //   label: 'Snapshot',
      //   icon: <SnapshotIcon />,
      //   path: '/myntra-snapshot'
      // },
      // {
      //   label: 'Master Overview',
      //   icon: <MasterOverviewIcon />,
      //   path: '/myntra-master-overview'
      // }
    ]
  },
  {
    title: 'Zepto',
    icon: <ZeptoIcon className="zepto-icon" />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/zepto'
      }
      // {
      //   label: 'Snapshot',
      //   icon: <SnapshotIcon />,
      //   path: '/myntra-snapshot'
      // },
      // {
      //   label: 'Master Overview',
      //   icon: <MasterOverviewIcon />,
      //   path: '/myntra-master-overview'
      // }
    ]
  },
  {
    title: 'Bigbasket',
    icon: <BigbasketIcon className="bigbasket-icon" />,
    items: [
      {
        label: 'Targeting 360',
        icon: <DashboardIcon />,
        path: '/summary/bigbasket'
      }
      // {
      //   label: 'Snapshot',
      //   icon: <SnapshotIcon />,
      //   path: '/myntra-snapshot'
      // },
      // {
      //   label: 'Master Overview',
      //   icon: <MasterOverviewIcon />,
      //   path: '/myntra-master-overview'
      // }
    ]
  },
  {
    title: 'Settings',
    icon: <SettingsIcon />,
    items: [
      {
        label: 'Hector Registrations',
        icon: <HectorIcon />,
        path: '/admin/hector-registrations'
      },
      // {
      //   label: 'User Activity Dashboard',
      //   icon: <UserActivityIcon />,
      //   path: '/app-user-tracking'
      // },
      {
        title: 'User Activity',
        icon: <UserActivityIcon />, 
        items: [
          { label: 'Retention Dashboard', icon: <DashboardIcon fillColor='#fff' height="20px" width="20px" />, path: '/user-activity/retention-dashboard', isBeta: true },
          { label: 'Time spend', icon: <DashboardIcon fillColor='#fff' height="20px" width="20px" />, path: '/user-activity/time-spend-dashboard', isBeta: true },
          // { label: 'Timespend Old', icon: <DashboardIcon fillColor='#fff' height="20px" width="20px" />, path: '/app-user-tracking' },
          // { label: 'Settings', icon: <SettingsIcon fillColor='#fff' height="20px" width="20px" />, path: '/app-usage-settings' },
        ],
      },
      // {
      //   label: 'User Activity Dashboard',
      //   icon: <UserActivityIcon />,
      //   path: '/user-activity/dashboard'
      // },
      // {
      //   label: 'User Activity Timespend',
      //   icon: <TimeSpendIcon />,
      //   path: '/user-activity/timespend'
      // },
      // {
      //   label: 'User Clients Dashboard',
      //   icon: <ClientListIcon />,
      //   path: '/user-activity/clients'
      // },
      {
        label: 'User Account Details',
        icon: <UserAccountDetailsIcon />,
        path: '/admin/useraccountdetails'
      },
      {
        label: 'Custom Payments',
        icon: <CustomPaymentsIcon />,
        path: '/custom/payments'
      },
      {
        label: 'Custom Access Details',
        icon: <ClientAccessIcon />,
        path: '/admin/client-access-details'
      },
      {
        label: 'Manual Transaction Details',
        icon: <ClientAccessIcon />,
        path: '/admin/manual-transaction-details'
      },
      {
        label: 'Master Dayparting Tracking',
        icon: <DaypartIconIcon />,
        path: '/master-dayparting-tracking'
      }
      // {
      //   label: 'Hector GPT',
      //   icon: <HectorGptIcon />,
      //   path: '/amazon-chatgpt'
      // },
    ]
  },
  {
    label: 'Admin Settings',
    icon: <BillingMenuIcon />,
    path: '/sponsored-ads/dashboard/settings?countryCode=all'
  },
];

export default newMenuItems;
